export const useFormFieldsIsRequired = (fields: Ref<FormField[]>) => {
  const isFieldsRequired = (_fields: FormField[]) => {
    return _fields.some((field) => isFieldRequired(field));
  };

  const hasFieldsReaquired = computed(() => isFieldsRequired(fields.value));

  return {
    hasFieldsReaquired,
  };
};
